export const IMGPW = process.env.NEXT_PUBLIC_IMAGE_PATH + '/website';
export const IMGPI = process.env.NEXT_PUBLIC_IMAGE_PATH + '/icons';